<template>
  <div class="tag_container">
    <el-container>
      <el-aside width="240px" >
        <TitleTagsAside :imageName="config.about.imageName"
                        :chineseStr="config.about.chineseStr"
                        :englishStr="config.about.englishStr"
                        :tags="config.about.tags"
                        @chooseitem="getChooseItem">
        </TitleTagsAside>
      </el-aside>

      <el-container>

        <el-header >
          <TitleTagsHead :tagName="tagName"></TitleTagsHead>
        </el-header>
        <el-main>

          <div>
            <router-view></router-view>
          </div>

        </el-main>

      </el-container>

    </el-container>

  </div>
</template>

<script>
import TitleTagsHead from '../../widgets/TitleTagsHead'
import TitleTagsAside from '../../widgets/TitleTagsAside'
import Config from '../../../../js/pc/Config'

export default {
  name: 'About',
  components: {TitleTagsHead, TitleTagsAside},
  data () {
    return {
      config: Config,
      tagName: Config.about.tags[0].name
    }
  },
  methods: {
    getChooseItem (data) {
      this.tagName = data.name
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/about/About.vue